export { WatchProjectHero } from './WatchProjectHero'
export type { BackgroundPosition } from './WatchProjectHero'
